<template>
  <div class="app">
    <slot name="header">
      <header class="app__header">
        <div class="app__header__left">
          <slot name="header__left"></slot>
        </div>

        <div class="app__header__center">
          <slot name="header__center"></slot>
        </div>
        <div
          v-if="slots.header__right"
          class="app__header__right"
        >
          <slot name="header__right"></slot>
        </div>
      </header>
    </slot>
    <main
      class="app__main"
    >
      <template v-if="!$route.meta?.isSlim">
      </template>

      <section
        v-if="slots.main__center"
        class="app__main__center"
      >
        <div
          v-if="!$route.meta?.isSlim"
          class="app__main__center__header"
        >
          <template v-if="slots.main__center__header">
            <slot name="main__center__header"></slot>
          </template>
          <TheBreadcrumbs
            v-else
            v-bind="breadcrumbs"
          />
        </div>

        <div class="app__main__center__content">
          <slot name="main__center"></slot>
        </div>
      </section>
    </main>
    <footer
      v-if="slots.footer"
      class="app__footer"
    >
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script setup>
import {useSlots} from 'vue';

import {
  // TheBrand,
  TheBreadcrumbs,
  // TheProjectInfo,
} from '@sttedra_ui/framework';

// #region Props, Emits
defineProps({
  apiVersion: {
    type: String,
    default: '',
  },
  logo: {
    type: String,
    default: require('@/assets/images/logo.svg'),
  },
  mainNavRoutes: {
    type: Array,
    default: () => [],
  },
  breadcrumbs: {
    type: Object,
    default: () => ({}),
  },
});
// #endregion


// #region Params, Ref, Reactives, Computed
const slots = useSlots();

// #endregion


// #region Functions
// ...
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
  .app {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100dvh;

    &__header {
      align-items: center;
      background-color: $brand__color--blue;
      display: flex;
      flex: 1 1 auto;
      min-height: $brand__boxspace--headerheight;
      position: relative;
      width: 100%;
      z-index: 20;

      &__left {
        align-items: center;
        display: flex;
        flex: 0 0 100%;
        height: 100%;
      }

      &__center {
        align-items: center;
        display: flex;
        flex: 1 1 100%;
        height: 100%;
        justify-content: flex-start;
      }

      &__right {
        align-items:center;
        display: flex;
        flex: 1 1 auto;
        flex-flow: row-reverse;
        height: 100%;
      }
    }

    &__main {
      align-items: stretch;
      display: flex;
      flex: 1 1 100%;
      width: 100%;

      &__left {
        background-color: $brand__color--blue;
        color: $brand__color--white;
        flex: 0 0 auto;
        position: relative;
        width: $brand__boxspace--panelwidth;
        z-index: 10;
      }

      &__center {
        align-items: stretch;
        display: flex;
        flex-direction: column;
        flex: 1 1 100%;
        justify-content: stretch;
        position: relative;

        &__header {
          align-items: center;
          display: flex;
          flex: 0 0 auto;
          height: $brand__boxspace--menusheight;
          justify-content: flex-start;
          padding: 0 $brand__boxspace--medium;
          width: 100%;
        }

        &__content {
          align-items: stretch;
          display: flex;
          flex: 1 1 100%;
          justify-content: center;
          position: relative;
          width: 100%;
        }
      }
    }

    &__footer {
      background-color: $brand__color--smoke;
      flex: 0 0 auto;
      position: relative;
      width: 100%;
      z-index: 11;
    }
  }

  .legacy {
    display: none;
  }
</style>
